export const questionNames = {
  UNIT_TEST_FRAMEWORK: 'unitTestFramework',
  INTEGRATION_TEST_FRAMEWORK: 'integrationTestFramework',
  NODE_VERSION_CATEGORY: 'nodeVersionCategory',
  PACKAGE_MANAGER: 'packageManager',
  PACKAGE_BUNDLER: 'packageBundler',
  PROJECT_TYPE: 'projectType',
  PROJECT_TYPE_CHOICE: 'projectTypeChoice',
  SHOULD_BE_SCOPED: 'shouldBeScoped',
  SCOPE: 'scope',
  AUTHOR_NAME: 'authorName',
  AUTHOR_EMAIL: 'authorEmail',
  AUTHOR_URL: 'authorUrl',
  HOST: 'host',
  CONFIGURE_LINTING: 'configureLint',
  PROVIDE_EXAMPLE: 'provideExample',
  DIALECT: 'dialect'
};
